import styled from '@emotion/styled'

import ContentWrapper from '@vio/atlas/helpers/ContentWrapper'
import {Grid} from '@vio/atlas/helpers/Grid/Grid'
import {Radio} from '@vio/atlas/Radio'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'

export const PageWrapper = styled(ContentWrapper)`
  display: flex;
  aligh-items: center;
  flex-direction: column;
`

export const RadioGroup = styled('div')`
  display: flex;
  gap: ${cssTheme.layout.spacing.s200};
  flex-wrap: wrap;
  margin-bottom: ${cssTheme.layout.spacing.s500};
`

export const PageTitle = styled(Text)`
  margin-bottom: ${cssTheme.layout.spacing.s300};
`

export const PageSubtitle = styled(Text)`
  margin: ${cssTheme.layout.spacing.s400} 0 ${cssTheme.layout.spacing.s000};
`

export const DescriptionWrapper = styled('div')`
  margin: ${cssTheme.layout.spacing.s400} 0;
  background-color: ${cssTheme.colors.background.neutral.c100};
  border-radius: ${cssTheme.layout.radius.lg};
  padding: ${cssTheme.layout.spacing.s400};
`
export const RouteInfoContainer = styled(Grid)`
  border: 1px solid ${cssTheme.colors.border.neutral.c100};
  border-radius: ${cssTheme.layout.radius.lg};
  background-color: ${cssTheme.colors.background.neutral.c050};
`

export const CustomRadio = styled(Radio)`
  border-radius: ${cssTheme.layout.radius.xxl};
  width: 100%;
`
